import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
  selector: 'ptl-medium-separator',
  templateUrl: './separator.component.html',
  styleUrls: ['./separator.component.scss'],
})
export class SeparatorComponent {
  private _canRemoveItem = true;

  @Input()
  set canRemoveItem(value) {
    if (typeof value === 'string') {
      this._canRemoveItem = JSON.parse(decodeURIComponent(value));
    } else {
      this._canRemoveItem = value;
    }
  }

  get canRemoveItem() {
    return this._canRemoveItem;
  }

  /** Emits separator removing event */
  @Output() removeSeparator = new EventEmitter<void>();

  showToolbar = false;

  @HostListener('document:click', ['$event'])
  onClick(event: Event) {
    const targetElement = event.target as Element;
    if (!targetElement.closest('.f_separator-toolbar') && !targetElement.closest('.f_separator-content')) {
      this.showToolbar = false;
    }
  }

  onRemoveSeparator(event: MouseEvent) {
    event?.stopPropagation();
    this.removeSeparator.emit();
  }
}
